export const convert12hTo24h = (hour12, period) => {
	if (period === 'AM') {
		return hour12 === 12 ? 0 : hour12;
	} else {
		return hour12 === 12 ? 12 : hour12 + 12;
	}
};

export const convert24hTo12h = (hour24) => {
	if (hour24 === 0) return { hour: 12, period: 'AM' };
	if (hour24 < 12) return { hour: hour24, period: 'AM' };
	if (hour24 === 12) return { hour: 12, period: 'PM' };
	return { hour: hour24 - 12, period: 'PM' };
};

/**
 * Returns time data arrays based on the format
 * @param {string} format - '24h' or '12h'
 * @return {Object} Object containing hours, minutes, and periods arrays
 */
export const getTimeFormatData = (format) => {
	const hours = format === '12h' ?
		Array.from({ length: 12 }, (_, i) => i + 1) : // 1-12 for 12h format
		Array.from({ length: 24 }, (_, i) => i); // 0-23 for 24h format

	const minutes = Array.from({ length: 60 }, (_, i) => i); // 0-59

	const periods = ['AM', 'PM']; // Only used for 12h format

	return {
		hours,
		minutes,
		periods
	};
};

/**
 * Gets initial state based on format and value
 * @param {Object} value - Time value object with hour, minute, and optional period
 * @param {string} format - '24h' or '12h'
 * @return {Object} Initial state object with hour, minute, and period
 */
export const getInitialState = (value, format) => {
	if (format === '12h') {
		const converted = convert24hTo12h(value?.hour || 0);
		return {
			hour: converted.hour,
			minute: value?.minute || 0,
			period: value?.period || converted.period
		};
	}
	return {
		hour: value?.hour || 0,
		minute: value?.minute || 0,
		period: 'AM'
	};
};

/**
 * Formats a single item value for display
 * @param {number|string} value - The value to format
 * @param {string} type - 'hour', 'minute', or 'period'
 * @return {string} Formatted value string
 */
export const formatItemValue = (value, type) => {
	if (type === 'hour' || type === 'minute') {
		return value < 10 ? `0${value}` : `${value}`;
	}
	return value; // period
};

/**
 * Formats time for display in the picker
 * @param {number} hour - Hour value
 * @param {number} minute - Minute value
 * @param {string} period - Period ('AM' or 'PM') for 12h format
 * @param {string} format - '24h' or '12h'
 * @return {string} Formatted time string
 */
export const formatTimeDisplay = (hour, minute, period, format) => {
	const formattedHour = hour < 10 ? `0${hour}` : `${hour}`;
	const formattedMinute = minute < 10 ? `0${minute}` : `${minute}`;
	const timeString = `${formattedHour}:${formattedMinute}`;

	if (format === '24h') {
		return `${timeString} hrs`;
	} else {
		return `${timeString} ${period || 'AM'}`;
	}
};
